import { EnumBusiness, EnumUserSourceType } from '../enums';

export const AppSourceIdForBU = {
  [EnumUserSourceType.rel]: EnumBusiness.REL,
  [EnumUserSourceType.bppNew]: EnumBusiness.SMB,
  [EnumUserSourceType.isg]: EnumBusiness.ISG,
  [EnumUserSourceType.ssg]: EnumBusiness.SSG,
};
